import { ChiptaElement, html, css, unsafeCSS } from 'chipta-libs/main.js';
import { getQueryParam } from 'chipta-libs/utils/url.js';
import 'chipta-libs/components/font-awesome.js';
import 'chipta-libs/components/styled-button.js';
import 'chipta-libs/components/arrow-link.js';
import 'chipta-libs/components/styled-input.js';


class LogIn extends ChiptaElement {

  static get properties() {
    return {
      email: { type: String },
      loading: { type: Boolean },
      saved: { type: Boolean },
      invalidEmail: { type: Boolean }
    };
  }

  render() {

    return html`

      <div id="page-container">

        <div></div>

        <div id="content-container">

          <div id="chipta-logo">
            <img src="img/logowhite.svg" id="chipta-logo">
          </div>

          <div id="pane">

            <h2>${gettext('log_in_at_chipta')}</h2>

            <div id="login-options">

              <div class="login-option">

                <h3>${gettext('visitor')}</h3>
                <p>${gettext('visitor_login_description')}</p>

                <styled-button
                  method="action"
                  href="/account/"
                  size="small"
                  wide
                >
                  ${gettext('visitor_login_button_text')}
                </styled-button>

              </div>

              <div class="login-option">

                <h3>${gettext('organizer')}</h3>
                <p>${gettext('organizer_login_description')}</p>

                <styled-button
                  method="action"
                  href="/dashboard/"
                  size="small"
                  wide
                >
                  ${gettext('organizer_login_button_text')}
                </styled-button>

              </div>

            </div>

            <div class="spread">

              <arrow-link id="back-to-website-link" direction="left" href=${this.backToWebsitePath}>
                ${gettext('back_to_website')}
              </arrow-link>

              <arrow-link href="/sign-up/">
                ${gettext('sign_up')}
              </arrow-link>

            </div>

          </div>

        </div>

        <footer id='footer'>
          ${interpolate(gettext('copyright'), {year: (new Date()).getFullYear()}, true)}
        </footer>

      </div>

      <div id="background"></div>

    `;

  }

  get backToWebsitePath() {

    const previousPath = getQueryParam('prev');

    if (previousPath) {
      return previousPath;
    }

    return "/";

  }

  static get styles() {

    return css`

        :host {
          display: block;
          height: 100vh;
        }

        * {
          box-sizing: border-box;
        }

        [hidden] {
          display: none;
        }

        #background {
          position: fixed;
          z-index: -10;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: ${unsafeCSS(_themeData.brand_primary_color)};
          background-image: url('img/dots.svg');
          background-repeat: no-repeat;
          background-position-y: bottom;
          background-size: 100%;
        }

        #page-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          min-height: 100vh;
        }

        #content-container {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        #chipta-logo {
          display: flex;
          justify-content: center;
          margin: 15px 0;
        }

        #pane {
          width: 100%;
          max-width: 800px;
          padding: 40px;
          border-radius: 10px;
          background: white;
          box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.04),
            0px 20px 25px rgba(0, 0, 0, 0.1);
          font-family: Roboto, sans-serif;
        }

        @media screen and (max-width: 500px) {
          #pane {
            border-radius: 0;
          }
        }

        h2 {
          font-size: 25px;
          text-align: center;
          margin-bottom: 35px;
        }

        h3 {
          font-size: 20px;
        }

        #pane p {
          display: block;
          margin-top: 15px;
          font-size: 14px;
          color: #808080;
        }

        #login-options {
          display: flex;
          justify-content: space-evenly;
          margin-bottom: 30px;
        }

        @media screen and (max-width: 500px) {

          #login-options {
            flex-direction: column;
          }

        }

        .login-option {
          background: ${unsafeCSS(_themeData.background_color)};
          padding: 25px;
          border-radius: 15px;
        }

        @media screen and (min-width: 501px) {

          .login-option:first-child {
            margin-right: 25px;
          }

        }

        @media screen and (max-width: 500px) {

          .login-option:first-child {
            margin-bottom: 25px;
          }

        }

        #footer {
          margin: 15px;
          color: white;
          font-size: 16px;
        }

    `;

  }

}

customElements.define('log-in', LogIn);
